import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { NP_API_URL, NP_SEARCH_DEBOUNCE_MS } from '../../utils/novaPostApi';

const NovaPostCityInput = ({ value, onCityChange, inputClassName }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchTimerRef = useRef(null);
  const searchRequestIdRef = useRef(0);

  useEffect(() => () => {
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchRequestIdRef.current += 1;
  }, []);

  const searchSettlements = (query) => {
    const requestId = ++searchRequestIdRef.current;

    axios
      .post(NP_API_URL, {
        modelName: 'AddressGeneral',
        calledMethod: 'searchSettlements',
        methodProperties: {
          CityName: query,
          Limit: '50',
          Page: '1',
        },
      })
      .then((response) => {
        if (requestId !== searchRequestIdRef.current) return;
        if (response.data.success) {
          const addresses = (response.data.data?.[0]?.Addresses || []).map((address) => ({
            present: address.Present,
            ref: address.Ref,
            deliveryCity: address.DeliveryCity,
          }));
          setSuggestions(addresses);
        } else {
          setSuggestions([]);
        }
      })
      .catch((error) => {
        if (requestId !== searchRequestIdRef.current) return;
        setSuggestions([]);
        console.error('Error fetching settlements:', error);
      });
  };

  const handleCityChange = (e) => {
    const inputValue = e.target.value;
    onCityChange({ present: inputValue, ref: null });

    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchRequestIdRef.current += 1;
    setSuggestions([]);

    if (inputValue.length > 0) {
      setShowSuggestions(true);
      searchTimerRef.current = setTimeout(() => searchSettlements(inputValue), NP_SEARCH_DEBOUNCE_MS);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchRequestIdRef.current += 1;
    onCityChange(suggestion);
    setShowSuggestions(false);
  };

  return (
    <div className='mb-3'>
      <label htmlFor='city'>Місто</label>
      <input
        type='search'
        className={inputClassName ? inputClassName : 'form-control'}
        name='city'
        placeholder='Введіть місто'
        onChange={handleCityChange}
        value={value}
        autoComplete='new-password'
      />
      {showSuggestions && (
        <ul className='list-group' style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              className='list-group-item'
              onClick={() => handleSuggestionClick(suggestion)}
              style={{ cursor: 'pointer' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            >
              {suggestion.present}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NovaPostCityInput;
